import React from 'react'
import { browserHistory } from 'react-router'

import {user} from '../../core/controllers/user';

export default class GetStarted extends React.Component {
    selectView(type) {
        user.saveUserView(type, function() {
            browserHistory.replace('/');
        });
    }
    render(){
        return (
            <div>
            <img class="background-image" src="/assets/img/apartment-balcony-buildings-city.png" />
            <div class="login-page">
                <div class="row">
                    <div class="col-md-4">
                        <div class="login-box" style={{margin: '20% auto'}}>
                            <div class="logo">
                            </div>
                            <div class="login-logo">
                                <a href="#"><b>Property </b>Management.</a>
                            </div>
                            <div class="login-box-body" style={{textAlign: 'center'}}>
                                <h4 style={{'borderBottom': '1px solid #e1e1e1','textAlign': 'center'}}>Perfect for any sized management.</h4>
                                <div class="form-group">
                                    <p>Automated rent collection.</p>
                                </div>
                                <div class="form-group">
                                    <p>Background screen tenants & leads.</p>
                                </div>
                                <div class="form-group">
                                    <p>Lead tracking.</p>
                                </div>
                                <div class="form-group">
                                    <p>End-to-end maintenance management.</p>
                                </div>
                                <div class="row">
                                    <div class="col-xs-3"></div>
                                    <div class="col-xs-6">
                                        <div class="loading"><i class="fa fa-cog fa-spin"></i></div>
                                        <button type="submit" onClick={this.selectView.bind(this, 1)} name="submit" id="login" class="btn btn-secondary btn-info btn-fill btn-block btn-flat" >Select</button>
                                    </div>
                                    <div class="col-xs-3"></div>
                                </div>
                                <div class="row">
                                    <div class="col-xs-12 text-center footer-login">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="login-box" style={{margin: '20% auto'}}>
                            <div class="logo">
                            </div>
                            <div class="login-logo">
                                <a href="#"><b>Building </b>Management.</a>
                            </div>
                            <div class="login-box-body" style={{textAlign: 'center'}}>
                                <h4 style={{'borderBottom': '1px solid #e1e1e1','textAlign': 'center'}}>Perfect for any sized building.</h4>
                                <div class="form-group">
                                    <p>Control & monitor building temperatures.</p>
                                </div>
                                <div class="form-group">
                                    <p>Monitor water detected - control cameras.</p>
                                </div>
                                <div class="form-group">
                                    <p>Manage access control.</p>
                                </div>
                                <div class="form-group">
                                    <p>Warranty & maintenance management.</p>
                                </div>
                                <div class="row">
                                    <div class="col-xs-3"></div>
                                    <div class="col-xs-6">
                                        <div class="loading"><i class="fa fa-cog fa-spin"></i></div>
                                        <button type="submit" onClick={this.selectView.bind(this, 2)} name="submit" id="login" class="btn btn-secondary btn-info btn-fill btn-block btn-flat" >Select</button>
                                    </div>
                                    <div class="col-xs-3"></div>
                                </div>
                                <div class="row">
                                    <div class="col-xs-12 text-center footer-login">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="login-box" style={{margin: '20% auto'}}>
                            <div class="logo">
                            </div>
                            <div class="login-logo">
                                <a href="#"><b></b>Both.</a>
                            </div>
                            <div class="login-box-body" style={{textAlign: 'center'}}>
                                <h4 style={{'borderBottom': '1px solid #e1e1e1','textAlign': 'center'}}>Ready for anything.</h4>
                                <div class="form-group">
                                    <p>Control & monitor building systems.</p>
                                </div>
                                <div class="form-group">
                                    <p>Manage leases & tenants.</p>
                                </div>
                                <div class="form-group">
                                    <p>Collect rent & screen tenants.</p>
                                </div>
                                <div class="form-group">
                                    <p>Warranty & maintenance management.</p>
                                </div>
                                <div class="row">
                                    <div class="col-xs-3"></div>
                                    <div class="col-xs-6">
                                        <div class="loading"><i class="fa fa-cog fa-spin"></i></div>
                                        <button type="submit" onClick={this.selectView.bind(this, 3)} name="submit" id="login" class="btn btn-secondary btn-info btn-fill btn-block btn-flat" >Select</button>
                                    </div>
                                    <div class="col-xs-3"></div>
                                </div>
                                <div class="row">
                                    <div class="col-xs-12 text-center footer-login">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/views/GetStarted/GetStarted.jsx